import EDC from '../../../shared/globals';

EDC.UI.Stars = function (x, y, scene, count) {
  this.scene = scene;
  this.count = count;
  this.x = x;
  this.y = y;
  this.width = 700;
  this.fillPercentage = 90;
  this.container = null;
  this.starsEmpty = [];
  this.starsGreen = [];
  this.starsRed = [];
  this.maxStarWidth = 50;
};

EDC.UI.Stars.prototype.create = function () {
  this.container = this.scene.add.container(this.x, this.y);
  this.addStars();
  this.scaleAndPlace();
};

EDC.UI.Stars.prototype.addStars = function () {
  for (let i = 0; i < this.count; i++) {
    this.starsEmpty.push(this.scene.add.sprite(0, 0, 'star-empty').setOrigin(0));
    this.starsGreen.push(this.scene.add.sprite(0, 0, 'star-green').setOrigin(0));
    this.starsRed.push(this.scene.add.sprite(0, 0, 'star-red').setOrigin(0));
  }
};

EDC.UI.Stars.prototype.scaleAndPlace = function () {
  const star = this.starsEmpty[0];
  const pWidth = this.width * this.fillPercentage / 100;
  let neededStarWidth = pWidth / this.count;
  if (neededStarWidth > this.maxStarWidth) {
    neededStarWidth = this.maxStarWidth;
  }
  const scale = neededStarWidth / star.width;
  const step = (this.width - pWidth) / this.count;
  for (let i = 0; i < this.count; i++) {
    this.starsEmpty[i].setScale(scale, scale);
    this.starsEmpty[i].setPosition((neededStarWidth + step) * i, 0);
    this.container.add(this.starsEmpty[i]);

    this.starsGreen[i].setScale(scale, scale);
    this.starsGreen[i].setAlpha(0);
    this.starsGreen[i].setPosition((neededStarWidth + step) * i, 0);
    this.container.add(this.starsGreen[i]);

    this.starsRed[i].setScale(scale, scale);
    this.starsRed[i].setAlpha(0);
    this.starsRed[i].setPosition((neededStarWidth + step) * i, 0);
    this.container.add(this.starsRed[i]);
  }
};

EDC.UI.Stars.prototype.setCorrect = function (index) {
  this.starsEmpty[index].setAlpha(0);
  this.starsGreen[index].setAlpha(1);
};

EDC.UI.Stars.prototype.setWrong = function (index) {
  this.starsEmpty[index].setAlpha(0);
  this.starsRed[index].setAlpha(1);
};

export default EDC.UI.Stars;
